import { MandateState } from 'src/models';

export const isMandateRevoked = (type: MandateState) => type === 'Deleted';

export const isMandateNew = (type: MandateState) => type === 'New';

export const isMandateActive = (type: MandateState) => type === 'Active';

export const isMandateInactive = (type: MandateState) => type === 'Inactive';
